import * as actionTypes from '../action-types';
import { UserReducerType } from '../userState.types';
import { UserActions } from '../actions';

/* DEPRECATED : USE USER CONTEXT */
export const defaultState: UserReducerType = {
  quotaExceeded: false,
  accessPremium: false,
  /** DEPRECATED : use currentUser.status instead in user context
   * and compare with userStatusConstants */
  trialExpired: false,
};

export function userReducer(
  state: UserReducerType = defaultState,
  action: UserActions,
) {
  switch (action.type) {
    case actionTypes.SET_QUOTA_EXCEEDED: {
      return {
        ...state,
        quotaExceeded: true,
      };
    }
    case actionTypes.SET_TRIAL_EXPIRED: {
      return {
        ...state,
        trialExpired: true,
      };
    }
    default: {
      return state;
    }
  }
}
